import { defineStore } from 'pinia';
import moment from 'moment';
import PublicService from '@/services/public.service';

export const useInscriptionVIPStore = defineStore('inscriptionVIP', {
    state: () => ({
        id: null,
        id_module: null,
        id_commande: null,
        token: null,
        nb_inscrits: 1,
        doit_payer_course: true,
        filter_parcours: [],
        limit_acces_parcours: false,
        doit_payer_option: true,
        acces_options_completes: false,
        doit_payer_activite: true,
        acces_activites_completes: false,
        mail: "",
        for_billetterie: false,
        date_creation: moment().format("YYYY-MM-DD HH:mm:ss"),
        date_utilisation: null,
        date_expiration: null,
        actif: false,

    }),
    actions: {
        async fetch() {
            let res = await PublicService.getLienVIP(this.id_module, this.token);
            if (res) {
                this.set(res);
            }
        },

        async fetch_multi_usage() {
            let res = await PublicService.getLienVIPMultiUsage(this.id_module, this.token);
            if (res) {
                this.set(res);

            }
        },

        set(data) {
            this.id = data.id;
            this.id_module = data.id_module;
            this.id_commande = data.id_commande;
            this.token = data.token;
            this.nb_inscrits = data.nb_inscrits;
            this.doit_payer_course = data.doit_payer_course;
            this.filter_parcours = data.filter_parcours;
            this.limit_acces_parcours = data.limit_acces_parcours;
            this.doit_payer_option = data.doit_payer_option;
            this.acces_options_completes = data.acces_options_completes;
            this.doit_payer_activite = data.doit_payer_activite;
            this.acces_activites_completes = data.acces_activites_completes;
            this.mail = data.mail;
            this.for_billetterie = data.for_billetterie;
            this.date_creation = data.date_creation;
            this.date_utilisation = data.date_utilisation;
            this.date_expiration = data.date_expiration;
            this.actif = data.actif;
        },

        is_valid() {
            if (!this.id) return false;
            if (!this.actif) return false;
            if (this.date_expiration != '0000-00-00 00:00:00' && moment(this.date_expiration).isBefore(moment())) return false;
            if (this.date_utilisation != '0000-00-00 00:00:00') return false;
            return true;
        },

        get_status() {
            if (!this.id) {
                return "Ce lien d'inscription VIP n'est pas valide.";
            }
            if (!this.actif) {
                return "Malheureusement ce lien d'inscription VIP n'est plus valide, il a été désactivé."
            }
            if (this.date_expiration != '0000-00-00 00:00:00' && moment(this.date_expiration).isBefore(moment())) {
                return "Malheureusement ce  lien d'inscription VIP n'est plus valide, il a expiré le " + moment(this.date_expiration).format("DD/MM/YYYY") + ".";
            }
            if (this.date_utilisation != '0000-00-00 00:00:00') {
                return "Malheureusement ce lien d'inscription VIP n'est plus valide, il a été utilisé le " + moment(this.date_utilisation).format("DD/MM/YYYY") + ".";
            }
            let response = "";
            if (this.nb_inscrits) {
                response += "Ce lien permet l'inscription de " + this.nb_inscrits + " personne(s).";
            }
            if (this.limit_acces_parcours == "1") {
                response += " L'inscription aux parcours est limité à la séléction définie par l'organisateur ";
                let selection = "(";
                selection += this.filter_parcours
                    .filter((course) => course.selected)
                    .map((course) => course.nom)
                    .join(", ");
                selection += ").";
                response += selection;
            }
            if (this.doit_payer_course == "0") {
                response += " L'inscription aux parcours est gratuite.";
            }

            if (this.doit_payer_option == "0") {
                response += " L'inscription aux options est gratuite.";
            }
            if (this.acces_options_completes == "1") {
                response += " L'inscription aux options complètes est autorisée.";
            }
            if (this.doit_payer_activite == "0") {
                response += " L'inscription aux activités est gratuite.";
            }
            if (this.acces_activites_completes == "1") {
                response += " L'inscription aux activités complètes est autorisée.";
            }

            return response;
        }
    },

});